import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { ColDef, GridOptions } from 'ag-grid-community';
import React, { useCallback, useMemo, useRef } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { RefundOrder } from '../../models/RefundOrder';

interface RefundsAgGridTableProps {
  orders: RefundOrder[];
  isFetching?: boolean;
  selectedColumns?: string[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  refetch?: () => void;
}

export const RefundsAgGridTable = React.memo(function RefundsAgGridTable({
  orders,
  isFetching = false,
  selectedColumns = [],
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: RefundsAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);
  const handleGridReady = useCallback(() => {}, []);

  const { filteredColumnDefs } = useAgGridColumns({ selectedColumns });
  const columnDefsWithRenderers: ColDef[] = filteredColumnDefs;
  const gridOptions = useMemo<GridOptions<RefundOrder>>(
    () => ({
      // AG Grid necesita un id unico por fila; RefundOrder no expone `id`, usa `order_id`.
      getRowId: (params) => String(params.data.order_id),
    }),
    [],
  );

  return (
    <div
      className={`w-full transition-opacity duration-300 ${
        isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none' : ''
      }`}
    >
      <AgGridTable
        ref={agGridRef}
        data={orders}
        columnDefs={columnDefsWithRenderers}
        height="calc(100vh - 190px)"
        enableSelection={false}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        gridOptions={gridOptions}
      />
    </div>
  );
});
